import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconDefinition, faFacebook, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { finalize } from 'rxjs';
import { APP_SETTINGS, AppSettings } from 'src/app.settings';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { LoadingService } from 'src/app/services/loading-service.service';
import { LocaleService } from 'src/app/services/locale.service';
import { UtilityService } from 'src/app/services/openapi/api/api';
import { JobPostingResponse } from 'src/app/services/openapi/model/models';
import { COUNTRY_SUBDIVISIONS, PCL_OPERATING_COUNTRIES } from 'src/app/shared/constants';

@Component({
  selector: 'app-share-posting',
  templateUrl: './share-posting.component.html',
  styleUrls: ['./share-posting.component.scss'],
  imports: [FormsModule, CdkCopyToClipboard, MatButtonModule, MatDividerModule, FaIconComponent],
})
export class SharePostingComponent implements OnInit {
  private readonly appSettings: AppSettings = inject(APP_SETTINGS);
  private readonly snackBar: MatSnackBar = inject(MatSnackBar);
  private readonly localeService: LocaleService = inject(LocaleService);
  private readonly loadingService: LoadingService = inject(LoadingService);
  private readonly utilityService: UtilityService = inject(UtilityService);
  readonly breakpointService: BreakpointService = inject(BreakpointService);
  readonly faXTwitter: IconDefinition = faXTwitter;
  readonly faFacebook: IconDefinition = faFacebook;
  readonly faLinkedin: IconDefinition = faLinkedin;
  posting = inject<JobPostingResponse>(MAT_DIALOG_DATA);
  postingUrl: URL;
  postingUrlDisplay = '';

  constructor() {
    console.log(this.posting);
    console.log(this.appSettings.BaseUrl);
    this.postingUrl = new URL(this.appSettings.BaseUrl);
    this.postingUrl.pathname = `${this.localeService.languageCode}-${this.posting.isoCountryCode.toUpperCase()}/jobs/${this.posting.jobPostingNumber}`;
    console.log(this.postingUrl.href);
  }

  ngOnInit(): void {
    if (this.appSettings.GenerateShortUrls) {
      this.loadingService.loadingOn();
      this.utilityService
        .shortenUrl(this.postingUrl.href)
        .pipe(
          finalize(() => {
            this.loadingService.loadingOff();
            this.postingUrlDisplay = this.postingUrl.href;
          })
        )
        .subscribe({
          next: (shortUrl) => {
            this.postingUrl = new URL(shortUrl);
          },
          error: (error) => {
            console.error(error);
            // Do nothing and leave postingUrl as raw
          },
        });
    } else {
      this.postingUrlDisplay = this.postingUrl.href;
    }
  }

  getPostingLocationDisplayString(jobPosting: JobPostingResponse): string {
    const strings = [
      jobPosting.city,
      COUNTRY_SUBDIVISIONS[jobPosting.isoSubdivisionCode] ?? jobPosting.isoSubdivisionCode,
      PCL_OPERATING_COUNTRIES[jobPosting.isoCountryCode] ?? jobPosting.isoCountryCode,
    ].filter((x) => x);
    return strings.join(', ');
  }

  copyToClipboard() {
    this.snackBar.open('Link copied to clipboard', undefined, {
      duration: 3000,
      horizontalPosition: 'start',
      verticalPosition: 'bottom',
    });
  }

  getFacebookShareUrl(): URL {
    return new URL(`https://www.facebook.com/sharer/sharer.php?u=${this.postingUrl.href}&amp;src=sdkpreparse`);
  }

  getTwitterShareUrl(): URL {
    return new URL(`https://twitter.com/intent/tweet?text=${this.postingUrl.href}`);
  }

  getLinkedInShareUrl(): URL {
    return new URL(`https://www.linkedin.com/sharing/share-offsite/?url=${this.postingUrl.href}`);
  }
}
